// src/components/BackOnly.js
import { useNavigate, useLocation } from "react-router-dom";
import "./BackOnly.css";
import FollowFacebook from "./FollowFacebook";
import FollowInstagram from "./FollowInstagram";

export default function BackOnly() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleBack = () => {
    if (state?.backRoute) {
      navigate(state.backRoute);
      return;
    }
    navigate(-1);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      <button
        className="back-button"
        onClick={handleBack}
        style={{
          padding: "8px 14px",
          backgroundColor: "#eee",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "bold",
          margin: "20px"
        }}
      >
        ← Back
      </button>

      {/* ⭐ ONLY ADDING SOCIAL ICONS — NOTHING ELSE CHANGED */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "-10px",
          marginBottom: "10px"
        }}
      >
        <FollowFacebook />
        <FollowInstagram />
      </div>
    </div>
  );
}